import herocover from "../Assets/images/2-5.jpg"

export default function Hero() {
    return (
        <div className="hero">
            <img src={herocover} alt="" />
        </div>
    )
}
